// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"iW","contentFrame":"iX","buttonGroup":"iY","button":"iZ","header":"i0","text":"i1","contentImage":"i2"};